// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck.ck-labeled-field-view .ck-labeled-field-view__status{\n  font-size:var(--ck-font-size-small);\n  white-space:normal\n}[dir] .ck.ck-labeled-field-view .ck-labeled-field-view__status{\n  margin-top:var(--ck-spacing-small)\n}\n\n.ck.ck-labeled-field-view .ck-labeled-field-view__status_error{\n  color:var(--ck-color-base-error)\n}\n\n.ck.ck-labeled-field-view>.ck.ck-label{\n  width:100%;\n  text-overflow:ellipsis;\n  overflow:hidden\n}", ""]);
// Exports
module.exports = exports;
